var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.id)?_c('div',{staticClass:"spinner-layout",class:{
    opaque: _vm.global,
    zeroPosition: _vm.zeroPosition,
  },attrs:{"id":_vm.id}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"rect1"}),_vm._v(" "),_c('div',{staticClass:"rect2"}),_vm._v(" "),_c('div',{staticClass:"rect3"}),_vm._v(" "),_c('div',{staticClass:"rect4"}),_vm._v(" "),_c('div',{staticClass:"rect5"})])
}]

export { render, staticRenderFns }